import { Inject, Injectable, OnInit } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service'
import { UserModel } from './sections/users/user_model'
import { LoadingService } from './shared/components/loading.service'
import { Router } from '@angular/router'
import { resolve } from 'path'

@Injectable({
  providedIn: 'root',
})
export class AuthStateService implements OnInit {
  private loggedIn = new BehaviorSubject<boolean | null>(null)
  private user = new BehaviorSubject<UserModel | null>(null)
  private permissionList = new BehaviorSubject<string[]>([])
  private sessionReadySubject = new BehaviorSubject<boolean>(false);
  sessionReady$ = this.sessionReadySubject.asObservable();
  permissions = this.permissionList.asObservable()
  isLoggedIn = this.loggedIn.asObservable()
  userEvent = this.user.asObservable()

  constructor(
    private loadingService: LoadingService,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
  ) {
    this.loadingService.setLoading(true)
  }

  ngOnInit(): void {}

  setLoggedIn(status: boolean | null): void {
    if (!status) {
      this.logout()
    }
    this.loggedIn.next(status)
  }

  setUserInformation(userInfo: UserModel): void {
    this.user.next(userInfo)
    this.storage.set('user', userInfo)
  }

  setUserPermissions(permissions: any): void {
    this.permissionList.next(permissions)
  }

  private clearUserInformation(): void {
    this.storage.remove('user')
    this.user.next(null)
  }

  public async checkLoginStatus(): Promise<void> {
    this.loadingService.setLoading(true)
    const storedUser = this.storage.get('user')
    if (storedUser) {
      this.setLoggedIn(true)
      this.setUserInformation(storedUser)
    } else {
      this.setLoggedIn(false)
    }
    this.loadingService.setLoading(false)
  }

  logout(): void {
    this.clearUserInformation()
  }

  getUserInformation(): UserModel | null {
    return this.storage.get('user')
  }

  setSessionReady(ready: boolean): void {
    this.sessionReadySubject.next(ready);
  }
}
